<template>
   <div class="teaching">
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
         <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >考试教材</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="teaching-box main">
           <div class="main-bav flex-align-between">
             <div class="bav-left">
               <img src="../../assets/home/123.png" alt="">
             </div>
             <div class="bav-right">
               <div class="container">{{title}}
                 
               </div>
             </div>
           </div>
           <div class="column flex-align-around">
             <div class="column-box " v-for="(item,index) in iconlist" :key="index">
              <div class="column-main flex-column-center">
                <img :src="item.icon" alt="">
                <p>{{item.name}}</p>
                <p class="flex-align-center"><span></span></p>
                <p class="">{{item.title}}</p>
              </div>
             </div>
           </div>
           <div class="series">
             <h1>考试教材系列</h1>
             <div class="series-list flex-align-wrap">
               <div class="series-item" v-for="(item,index) in TeachingList" :key="index" @click="getoDetail('/list/teaching/detail/',item)">
                 <div class="item-board">
                   <img :src="item.cover" alt="">
                   <p >{{item.title}}</p>
                 </div>
               </div>
             </div>
           </div>
        </div>
        <footer-view></footer-view>
        <!-- <scorllTop></scorllTop> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
          title:'首师大出版社依托教育部考试中心书画等级考试（CCPT）北京考试办公室，组织编写了书画等级考试（CCPT）辅导丛书，丛书依据教育部考试中心书画等级考试（CCPT）2020版考试大纲编写，分别为毛笔书法、硬笔书法、国画（山水、人物、花鸟）、素描、色彩、动漫画，紧扣大纲、内容翔实、重点突出。',
            iconlist:[
              {
                icon:require('../../assets/home/icon/quanwei.png'),
                name:'权威',
                title:'丛书由教育部考试中心书画等级考试北京考试办公室指导，著名教育家顾明远先生担纲顾问，赵宏、陶冶等著名艺术教育专家编写，紧扣书画等级考试(CCPT)2020版考试大纲，服务书画等级考试广大师生。'
              },
              {
                icon:require('../../assets/home/icon/shiyong.png'),
                name:'实用',
                title:'内容设计从大纲解读、理论概述、专项辅导与练习、历年样卷分析等角度展开，编写规范、系统、循序渐进。适用于考生考前适应考试内容及考试流程。'
              },{
                icon:require('../../assets/home/icon/tifen.png'),
                name:'提分',
                title:'除内容细节外，全书还附有考试大纲标准、模拟真题，覆盖大纲要求重点、难点，助力考生在模拟实践中强化训练。通过模拟真题强化训练，提升考生考试通过率。'
              }
            ],
            TeachingList:[],
        }
    },
    computed:{
    },
    methods: { 
         async getNewsTeachingList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:6,
                pageNum:1,
                pageSize:10,
            }
            let resData = await Api.Home.getNewsList(params);
            this.TeachingList = resData.rows;

        },
        async getoDetail(path,item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
                let msg = {id:item.dId,type:item.clazz}
                // if(item.dId==161){
                //   return
                // }
                this.$router.push(path+item.dId ,msg)
            }
        },
    },
    mounted() {
       this.getNewsTeachingList()
    },
    beforeDestroy() {
   
}
}
</script>

<style lang="less" scoped>
 @import "./less/news_common.less";
  @basisColor:#1c4b90;
  @bgColor:#eef3f6;
  @white:#fff;
  .teaching {
    background-color: @white;

    .main {
        width: 1200px;
        margin: 0 auto;
    }
    .teaching-box {
      .main-bav {
        .bav-left {
          width: 564px;
          height: 432px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .bav-right {
            background-image: url("../../assets/home/teach.png");
            background-repeat: no-repeat;
            height: 432px;
            width: 606px;
            background-size:cover;
            background-position: 50% 0;
            .container {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 35px;
              padding:110px 76px 110px;
            }
        }
      }
      .column {
        padding:30px 0;
        .column-box {
          flex:1;
          padding:30px;
          &:first-child{
            padding-left:0;
          }
          &:last-child {
            padding-right:0;
             
          }
        }
        
        .column-main {
          border:1px solid #ECECEC;
          border-radius: 12px;
          padding:50px 40px;
          p:nth-child(2){
            padding-top:40px;
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #666666;
          }
           p:nth-child(3){
             width: 200px;
             background: #ECECEC;
             height: 1px;
             margin:20px 0;
            // border: 1px solid #666666;
            // position: relative;
            span {
              // position: ;
              display: inline-block;
              width: 44px;
              height: 6px;
              background: #CC4C4D;
            }
          }
          p:nth-child(4){
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
            height: 130px;
            // overflow:hidden; 
            //   text-overflow:ellipsis;
            //   display:-webkit-box; 
            //   -webkit-box-orient:vertical;
            //   -webkit-line-clamp:4; 
          }
        }
      }
      .series{
          padding:0 0 30px 0;
        h1 {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        .series-list {
          width: 100%;
          .series-item {
            margin-right:15px;
            width: calc((100% / 5) - 15px );
            padding:30px 0;
            .item-board {
              padding:20px;
            background: #FFFDFE;
            border: 1px solid #E9E9E9;
            border-radius: 5px;
              img {
                // width: 174px;
                width: 100%;
                height: 174px;

              }
              p {
                width: 174px;
                // text-align: center;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                overflow:hidden; 
              text-overflow:ellipsis;
              display:-webkit-box; 
              -webkit-box-orient:vertical;
              -webkit-line-clamp:2; 
              }
            }
          }
        }
      }
    }
    
  }
</style>